import '../../styles/pages/converter-page.scss';

import '../components/currencies/converter'

/*
* Currencies dropdown elements
*/

const form = document.querySelector('.converter-block__form');
const [firstInputEl, secondInputEl] = form.querySelectorAll('.converter-block__form-input');

const [dropdownBtnFirstInputEl,
  dropdownBtnSecondInputEl] = [
    firstInputEl.querySelector('.converter-dropdown__selected'),
    secondInputEl.querySelector('.converter-dropdown__selected')
  ];

const [dropdownFirstInputEl,
  dropdownSecondInputEl] = [
    firstInputEl.querySelector('.converter-dropdown__list'),
    secondInputEl.querySelector('.converter-dropdown__list')
  ];

let [selectedCurrencyFirst,
  selectedCurrencySecond] = [
    {
      label: dropdownBtnFirstInputEl.children[0].textContent,
      value: dropdownBtnFirstInputEl.dataset.value
    },
    {
      label: dropdownBtnSecondInputEl.children[0].textContent,
      value: dropdownBtnSecondInputEl.dataset.value
    },
  ];

// on input-btn click to open dropdown
dropdownBtnFirstInputEl.addEventListener('click', () => {
  if (firstInputEl.classList.contains('converter-dropdown_opened')) {
    firstInputEl.classList.remove('converter-dropdown_opened')
  } else {
    firstInputEl.classList.add('converter-dropdown_opened')
  }
});

dropdownBtnSecondInputEl.addEventListener('click', () => {
  if (secondInputEl.classList.contains('converter-dropdown_opened')) {
    secondInputEl.classList.remove('converter-dropdown_opened')
  } else {
    secondInputEl.classList.add('converter-dropdown_opened')
  }
});

const handleCurrencyChange = (e, rank) => {
  const el = e.target;
  const value = el.dataset?.value;

  if (value) {
    if (rank === 'first') {
      selectedCurrencyFirst = { value, label: el.textContent };
      firstInputEl.classList.remove('converter-dropdown_opened');
      dropdownBtnFirstInputEl.children[0].innerHTML = selectedCurrencyFirst.label;
    } else {
      selectedCurrencySecond = { value, label: el.textContent };
      secondInputEl.classList.remove('converter-dropdown_opened');
      dropdownBtnSecondInputEl.children[0].innerHTML = selectedCurrencySecond.label;
    }
  }
}

// on list-item-click
dropdownFirstInputEl.addEventListener('click', (e) => handleCurrencyChange(e, 'first'));
dropdownSecondInputEl.addEventListener('click', (e) => handleCurrencyChange(e, 'second'));

// click outside of the currency-dropdown
document.addEventListener('click', (e) => {
  const el = e.target;

  if (!firstInputEl.contains(el)) {
    firstInputEl.classList.remove('converter-dropdown_opened');
  }

  if (!secondInputEl.contains(el)) {
    secondInputEl.classList.remove('converter-dropdown_opened');
  }
});

/////////////////////////////////////////////////////////

/*
* Swap currencies button
*/

// const [firstInput, secondInput] = [form.querySelector('input[name="first"]'), form.querySelector('input[name="second"]')];

// form.addEventListener('submit', (e) => {
//     e.preventDefault();
//     const firstInputValue = firstInput.value;
//     const secondInputValue = secondInput.value;
//     // TODO: Conversion itself
//     firstInput.value = secondInputValue;
//     secondInput.value = firstInputValue;
// })

/////////////////////////////////////////////////////////

/*
* Select rate dropdown
*/

const rateDropdown = document.querySelector('.converter-dropdown-rate');
const rateDropdownList = rateDropdown.querySelector('.converter-dropdown__list');
let selectedRate = { label: '', value: '' };

rateDropdown.addEventListener('click', (e) => {
  rateDropdown.classList.add('converter-dropdown_opened')
});

// click outside of the select-rate-dropdown
document.addEventListener('click', (e) => {
  if (!rateDropdown.contains(e.target))
    rateDropdown.classList.remove('converter-dropdown_opened');
});

rateDropdownList.addEventListener('click', (e) => {
  const el = e.target;
  const value = el.dataset?.value;
  if (value) {
    selectedRate = { value, label: el.textContent };
    rateDropdown.children[0].innerHTML = selectedRate.label;
    setTimeout(() => rateDropdown.classList.remove('converter-dropdown_opened'))
  }
})

const loadMoreBtn = document.querySelector('.load-more');

if (loadMoreBtn) {
  loadMoreBtn.addEventListener('click', (e) => {
    const fullLocationWithoutQuery = window.location.href.split('?')[0].slice(0, -10);
    const contentContainer = document.getElementById('grid-news');

    load_posts_by_page({
      path: `${fullLocationWithoutQuery}/load-financial-posts/`,
      content: contentContainer,
      btn: loadMoreBtn,
    })
  })
}